
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-general-enrichment-programme",
      function () {
        return require("private-next-pages/tnpsc-general-enrichment-programme/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-general-enrichment-programme"])
      });
    }
  